import type { TextVariant } from "@qendo/theme";
import type { ReactNode } from "react";
import { ChangeText } from "~/components/layout/text/ChangeText";

export type ColourProps = {
    colour: TextVariant;
    children: ReactNode;
};

export const Colour = ({ colour, children }: ColourProps) => {
    return <ChangeText colour={colour}>{children}</ChangeText>;
};
